import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import PaginaAutentificare from "./pagini/PaginaAutentificare";
import Dashboard from "./pagini/Dashboard";
import PaginaRapoarte from "./pagini/PaginaRapoarte";
import PaginaSetari from "./pagini/PaginaSetari";
import PaginaProfil from "./pagini/PaginaProfil";
import PaginaEroare from "./pagini/PaginaEroare";
import "./pagini/stiluri/App.css";
import AdaugareBeneficiar from "./pagini/AdaugareBeneficiar";
import BeneficiarDetalii from "./componente/BeneficiarDetalii";
import AdministrareUtilizatori from "./componente/AdministrareUtilizatori";
import Antet from "./componente/Antet";
import { auth } from "./pagini/Firebase"; // Importă autentificarea și baza de date Firebase
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { jwtDecode } from "jwt-decode";



const App = () => {
  const getUserRoleFromToken = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return "";
  try {
    const decoded = jwtDecode(token);
    return decoded.role || "user";
  } catch {
    return "";
  }
};

const [userRole, setUserRole] = useState(getUserRoleFromToken())

  const [loading, setLoading] = useState(true); // Gestionăm starea de încărcare
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // Verifică dacă utilizatorul este deja autentificat în localStorage
    return localStorage.getItem("isLoggedIn") === "true";
  });

  const onLogin = () => {
    setIsLoggedIn(true); // Setează utilizatorul ca autentificat
    localStorage.setItem("isLoggedIn", "true"); // Salvează starea autentificării
    // Salvează rolul în localStorage
  };


  const onLogout = () => {
    setIsLoggedIn(false); // Deconectează utilizatorul
    localStorage.removeItem("isLoggedIn"); // Șterge starea din localStorage
    localStorage.removeItem("userEmail"); // Șterge email-ul din localStorage, dacă este cazul
    localStorage.removeItem("userRole"); // Șterge rolul din localStorage, dacă este cazul



  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
        
          setLoading(false);
          return;
        }

       

        // Firestore setup
        const db = getFirestore();
        const usersCollection = collection(db, "Users");
        const q = query(usersCollection, where("email", "==", user.email));

        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const currentUser = querySnapshot.docs[0].data();
        

          // Actualizează rolul și salvează în localStorage
          if (currentUser.role) {
            setUserRole(currentUser.role);
            localStorage.setItem("userRole", currentUser.role);
          }
        } else {
          console.error("Utilizatorul nu a fost găsit în Firestore.");
        }
      } catch (error) {
        console.error(
          "Eroare la obținerea datelor utilizatorului:",
          error.message
        );
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (loading) {
    return <p>Se încarcă...</p>;
  }

  return (
    
    <Router>
      {isLoggedIn && <Antet onLogout={onLogout} userRole={userRole} />}  
      <Routes>
        {/* Redirect users to /dashboard if they are logged in */}
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" />
            ) : (
              <PaginaAutentificare onLogin={onLogin} />
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            isLoggedIn ? <Dashboard onLogout={onLogout} /> : <Navigate to="/" />
          }
        />
        <Route
          path="/rapoarte"
          element={
            isLoggedIn ? (
              <PaginaRapoarte onLogout={onLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/setari"
          element={
            isLoggedIn ? (
              <PaginaSetari onLogout={onLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/profil"
          element={
            isLoggedIn ? (
              <PaginaProfil onLogout={onLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/administrare-utilizatori"
          element={
            isLoggedIn ? (
              <AdministrareUtilizatori onLogout={onLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/adauga-beneficiar"
          element={
            isLoggedIn ? (
              <AdaugareBeneficiar onLogout={onLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/beneficiar/:id"
          element={
            isLoggedIn ? (
              <BeneficiarDetalii onLogout={onLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="*" element={<PaginaEroare />} />
      </Routes>
    
    </Router>
  );
};

export default App;
